import { render, staticRenderFns } from "./PaginationSkeleton.vue?vue&type=template&id=46072a57&scoped=true&"
import script from "./PaginationSkeleton.vue?vue&type=script&lang=js&"
export * from "./PaginationSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46072a57",
  null
  
)

export default component.exports